import { Phone, MessageCircle } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const LUXURY_QUOTES = [
  "Where Silver Meets Artistry",
  "Timeless Elegance, Crafted for You",
  "Heirloom Quality, Modern Design",
  "Pure Silver, Pure Luxury",
  "Crafted with Passion",
  "Every Piece Tells a Story",
];

const ProductCard = ({ product, index = 0 }) => {
  const primaryMedia = product.media && product.media.length > 0 ? product.media[0] : null;
  const whatsappNumber = "919104054259";
  const whatsappMessage = encodeURIComponent(`Hello, I'm interested in: ${product.title}`);
  const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${whatsappMessage}`;
  const quote = LUXURY_QUOTES[index % LUXURY_QUOTES.length];

  const getMediaUrl = (mediaPath) => {
    if (!mediaPath) return null;
    if (mediaPath.startsWith("http")) return mediaPath;
    return `${BACKEND_URL}${mediaPath}`;
  };

  return (
    <div data-testid={`product-card-${product.id}`} className="group">
      <div className="luxury-frame">
        <div className="aspect-[4/5] relative overflow-hidden bg-gradient-to-br from-pearl to-cream">
          {primaryMedia ? (
            primaryMedia.media_type === "video" ? (
              <video src={getMediaUrl(primaryMedia.media_path)} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-1000" muted loop autoPlay playsInline />
            ) : (
              <img src={getMediaUrl(primaryMedia.media_path)} alt={product.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-1000" />
            )
          ) : (
            <div className="w-full h-full flex flex-col items-center justify-center p-8 text-center">
              <div className="w-16 h-px bg-gradient-to-r from-transparent via-royal-gold to-transparent mb-6" />
              <p className="font-serif text-xl italic text-royal-gold/70 leading-relaxed">"{quote}"</p>
              <div className="w-16 h-px bg-gradient-to-r from-transparent via-royal-gold to-transparent mt-6" />
              <p className="font-display text-[10px] tracking-[0.3em] uppercase text-charcoal/30 mt-6">Image Coming Soon</p>
            </div>
          )}
        </div>
      </div>

      <div className="mt-6 text-center space-y-3">
        <h3 className="font-serif text-xl text-charcoal group-hover:text-royal-gold transition-colors">{product.title}</h3>
        <p className="font-body text-sm text-charcoal/50 line-clamp-2 max-w-xs mx-auto">{product.description}</p>

        <div className="flex items-center justify-center gap-3 pt-3">
          <a href="tel:+919104054259" data-testid={`product-call-${product.id}`}
            className="flex items-center space-x-2 px-5 py-2 border border-silver-dark/30 text-charcoal/70 text-xs font-display uppercase tracking-widest hover:border-royal-gold hover:text-royal-gold transition-all">
            <Phone size={12} /><span>Call</span>
          </a>
          <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" data-testid={`product-whatsapp-${product.id}`}
            className="flex items-center space-x-2 px-5 py-2 bg-[#25D366] text-white text-xs font-display uppercase tracking-widest hover:bg-[#20bd5a] transition-all">
            <MessageCircle size={12} /><span>Enquire</span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
